import React, { ButtonHTMLAttributes, FC, PropsWithChildren } from "react";

import {
  AudioStrippedButton,
  IconWrapper
} from "../YleAudioPlayer/AudioPlayerButtons";

interface Props
  extends PropsWithChildren, ButtonHTMLAttributes<HTMLButtonElement> {
  isMobile: boolean;
}

const IconButton: FC<Props> = ({ children, ...props }) => (
  <AudioStrippedButton {...props}>
    <IconWrapper>{children}</IconWrapper>
  </AudioStrippedButton>
);

export default IconButton;
